import {Fragment} from "preact";
import s from "./content.module.css";
import {useContent} from "./useContent";

import ProgressBar from "./ProgressBar";
import InitialSteps from "./InitialSteps";
import Background from "./Background";
import ThirdStep from "./ThirdStep";
import Alert from "./Alert";
import FourthStep from "./FourthStep";
import FifthStep from "./FifthStep";
import Finish from "./Finish";
import {useAppContext} from "../../../contexts";

const Content = (props) => {
    // Destructured props
    const {handleExpandAction} = props;

    // Component logic data
    const componentProps = useContent({
        handleExpandAction
    });

    // Destructured component logic data
    const {
        currentStep,
        surveyData,
        STEPS_AMOUNT,
        showAlert,
        hasSynchronizedThirdStep,
        handlePayloadUpdate,
        handleStepChange
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Flags whether the container content should be reversed or not
    const REVERSE_CONTENT = {
        1: false,
        2: false,
        3: true,
        4: true,
        5: false,
    }

    return (
        <Fragment>
            <div className="flex flex-col mx-auto w-full max-w-4xl px-6 md:px-4 py-6 sm:py-12 font-museo">
                <ProgressBar
                    stepsAmount={STEPS_AMOUNT}
                    currentStep={currentStep}
                />
                <div className={"my-20 md:my-28 relative z-0"}>
                    <div className={
                        `flex flex-col-reverse items-start justify-start gap-y-14 gap-x-10 md:gap-x-24 flex-nowrap transition-all duration-50 ${REVERSE_CONTENT[currentStep] ? "md:flex-row-reverse" : "md:flex-row"} ${highContrast ? s.darkModeFilter : ""}`
                    }>
                        {(currentStep >= 1 && currentStep < 6) && (
                            <InitialSteps
                                handleStepChange={handleStepChange}
                                currentStep={currentStep}
                                surveyData={surveyData.initialSteps}
                                handlePayloadUpdate={handlePayloadUpdate}
                            />
                        )}
                        {(currentStep >= 3 && currentStep < 6) && (
                            <Fragment>
                                <ThirdStep
                                    handleStepChange={handleStepChange}
                                    handlePayloadUpdate={handlePayloadUpdate}
                                    currentStep={currentStep}
                                    showAlert={showAlert}
                                />
                                <Alert
                                    showAlert={showAlert}
                                    hasSynchronizedThirdStep={hasSynchronizedThirdStep}
                                />
                            </Fragment>
                        )}
                        {(currentStep >= 4 && currentStep < 6) && (
                            <FourthStep
                                handleStepChange={handleStepChange}
                                handlePayloadUpdate={handlePayloadUpdate}
                                surveyData={surveyData.fourthStep}
                                currentStep={currentStep}
                            />
                        )}
                        {currentStep >= 5 && (
                            <FifthStep
                                handleStepChange={handleStepChange}
                                handlePayloadUpdate={handlePayloadUpdate}
                                currentStep={currentStep}
                            />
                        )}
                        {currentStep >= 6 && (
                            <Finish currentStep={currentStep} />
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Content;
